<template>
    <div class="w-100">
        <!-- Page title -->
        <div class="row align-items-center mt-1 mb-3">
            <div class="col-9">
                <h2 class="page-title">
                    {{ pageTitle }}
                </h2>
            </div>
        </div>

        <!-- Alert box -->
        <div v-show="this.v$.step[this.currentStep - 1].$error" class="alert alert-danger alert-dismissible" role="alert">
            <div class="d-flex">
                <div>
                    <!-- Download SVG icon from http://tabler-icons.io/i/alert-circle -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon alert-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <div>
                    <span v-if="v$.$errors.length > 1"> Sorry, there are ({{ this.v$.step[this.currentStep - 1].$errors.length }}) errors found please correct the errors to proceed.</span>
                    <span v-if="v$.$errors.length <= 1"> Sorry, there's ({{ this.v$.step[this.currentStep - 1].$errors.length }}) error found please correct the error to proceed.</span>
                </div>
            </div>
            <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
        </div>

        <form id="create-accident-incident-report" action="accident-incident-reports/store" class="add-accident-incident-report add-record">
            <div class="card" v-if="currentStep == 1" title="Registered Nurse Report">
                <div class="card-header">
                    <h3 class="card-title">Registered Nurse Report</h3>
                </div>

                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Was this incident preventable?</div>
                                <div class="form-check form-switch mb-0 ms-1">
                                    <input class="form-check-input" type="checkbox" name="incidentPreventable" v-model="step[0].incidentPreventable" />
                                    <span class="form-check-label">Yes, preventable</span>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].incidentPreventable.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3" v-if="step[0].incidentPreventable == true">
                                <div class="form-label">What has been done to prevent re-occurence? (if yes)</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="What has been done to prevent re-occurence"
                                    value=""
                                    spellcheck="false"
                                    name="doneToPreventReOccurence"
                                    v-model="step[0].doneToPreventReOccurence"
                                    :class="{
                                        'is-invalid': v$.step[0].doneToPreventReOccurence.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].doneToPreventReOccurence.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Comments</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Comments"
                                    value=""
                                    spellcheck="false"
                                    name="comments"
                                    v-model="step[0].comments"
                                    :class="{
                                        'is-invalid': v$.step[0].comments.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].comments.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">RN's signature</div>
                                <input
                                    type="text"
                                    class="form-control w-75 mt-2"
                                    name="registeredNurseSignature"
                                    placeholder="Enter full name to sign"
                                    v-model="step[0].registeredNurseSignature"
                                    :class="{'is-invalid': v$.step[0].registeredNurseSignature.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].registeredNurseSignature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3 row">
                                <div class="col-6">
                                    <div class="form-label">Family member notified</div>
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="familyMemberNotified"
                                        placeholder="Name of family member"
                                        v-model="step[0].familyMemberNotified"
                                        :class="{'is-invalid': v$.step[0].familyMemberNotified.$invalid}"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].familyMemberNotified.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="form-label">Date</div>
                                            <input
                                                type="date"
                                                class="form-control"
                                                name="familyMemberNotifiedDate"
                                                placeholder=""
                                                v-model="step[0].familyMemberNotifiedDate"
                                                :class="{'is-invalid': v$.step[0].familyMemberNotifiedDate.$invalid}"
                                            />
                                            <div
                                                class="invalid-feedback"
                                                :class="{
                                                    'd-block': v$.step[0].familyMemberNotifiedDate.$invalid,
                                                }"
                                            >
                                                Invalid feedback
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-label">Time</div>
                                            <input
                                                type="time"
                                                class="form-control"
                                                name="familyMemberNotifiedTime"
                                                placeholder="16:00"
                                                v-model="step[0].familyMemberNotifiedTime"
                                                :class="{'is-invalid': v$.step[0].familyMemberNotifiedTime.$invalid}"
                                            />
                                            <div
                                                class="invalid-feedback"
                                                :class="{
                                                    'd-block': v$.step[0].familyMemberNotifiedTime.$invalid,
                                                }"
                                            >
                                                Invalid feedback
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Other notifications to be made</div>
                                <input
                                    type="text"
                                    class="form-control w-75"
                                    name="otherNotificationsToBeMade"
                                    placeholder="Name of other person"
                                    v-model="step[0].otherNotificationsToBeMade"
                                    :class="{'is-invalid': v$.step[0].otherNotificationsToBeMade.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].otherNotificationsToBeMade.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Required assessments completed</div>
                                <div class="form-check form-switch mb-0 ms-1">
                                    <input class="form-check-input" type="checkbox" name="requiredAssessmentsCompleted" v-model="step[0].requiredAssessmentsCompleted" />
                                    <span class="form-check-label">Yes</span>
                                </div>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].requiredAssessmentsCompleted.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn invisible" id="last-save-btn">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack()" href="#" class="p-2 mx-3 d-block back-btn" id="last-back-btn">Cancel</a>
                        <a @click="onClickNext()" class="ml-5 btn btn-primary" id="submit-btn">Finish</a>
                    </p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {alpha, alphaNum, email, integer, required, requiredIf, minLength, maxLength, minValue, maxValue, helpers} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
    name: "addRNReportComponent",
    props: ["progressBar", "pageTitle", "residentId", "userId", "accidentIncidentReport", "cancelUrl"], // vue can read kebab props as camel cased vars
    components: {Multiselect},
    setup() {
        return {v$: useVuelidate()};
    },
    data() {
        var accidentIncidentReportObject = JSON.parse(this.accidentIncidentReport);
        var endpointToUse = location.protocol + "//" + window.location.host + "/api/accident-incident-report/" + accidentIncidentReportObject.id + "/" + process.env.MIX_API_KEY;

        // accidentIncidentReportObject["registered_nurse_report"] = JSON.parse(accidentIncidentReportObject["registered_nurse_report"]);

        // Return empty string when object doesn't exist
        // options - array | string
        function returnValueFromObject(fieldName, parent, defaultValue = "", options) {
            // Editing
            if (!_.isEmpty(accidentIncidentReportObject) && !_.isEmpty(accidentIncidentReportObject[parent])) {
                return accidentIncidentReportObject[parent][fieldName] ?? defaultValue;
            } else {
                return defaultValue;
            }
        }

        return {
            currentStep: 1,
            maxStep: 1,
            percentageComplete: 0,
            errors: 0,
            yesNoOptions: ["Yes", "No"],
            trueFalseOptions: [true, false],
            endpoint: endpointToUse,
            step: [
                // Step 1 - Registered Nurse Report
                {
                    incidentPreventable: returnValueFromObject("incidentPreventable", "registered_nurse_report"),
                    doneToPreventReOccurence: returnValueFromObject("doneToPreventReOccurence", "registered_nurse_report"),
                    comments: returnValueFromObject("comments", "registered_nurse_report"),
                    registeredNurseSignature: returnValueFromObject("registeredNurseSignature", "registered_nurse_report"),
                    familyMemberNotified: returnValueFromObject("familyMemberNotified", "registered_nurse_report"),
                    familyMemberNotifiedDate: returnValueFromObject("familyMemberNotifiedDate", "registered_nurse_report"),
                    familyMemberNotifiedTime: returnValueFromObject("familyMemberNotifiedTime", "registered_nurse_report"),
                    otherNotificationsToBeMade: returnValueFromObject("otherNotificationsToBeMade", "registered_nurse_report"),
                    requiredAssessmentsCompleted: returnValueFromObject("requiredAssessmentsCompleted", "registered_nurse_report"),
                },
            ],
        };
    },
    validations() {
        // Custom Validators
        const inArray = (array) => (value) => array.includes(value) || !helpers.req(value);
        const isDateFormat = (value) => value.match("^$|((?:[0-9]{2})?[0-9]{2})-(1[0-2]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])") || !helpers.req(value);
        const isTimeFormat = (value) => value.match("^$|^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$") || !helpers.req(value);
        const isTextWithSpecialCharacters = (value) => value.match("^[a-zA-Z0-9_ !@#$&%^*()`.+,/\\-\r\n\s'\"]*$") || !helpers.req(value);
        const isTextWithSpace = (value) => value.match("^[a-zA-Z0-9_ \s'\"]*$") || !helpers.req(value);

        const dateType = {
            required,
            isDateFormat,
            $lazy: true,
            $autoDirty: true,
        };

        const timeType = {
            required,
            isTimeFormat,
            $lazy: true,
            $autoDirty: true,
        };

        // TEXT TYPES: default: 191, mid:500, long:1000
        function text(minimum = 3, maximum = 191, isRequired = false, allowSpecial = false) {
            if (allowSpecial) {
                var rule = {
                    required,
                    isTextWithSpecialCharacters,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };
            } else {
                var rule = {
                    required,
                    isTextWithSpace,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };
            }

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule["required"];
            }
            return rule;
        }

        // ARRAY TYPES
        function inOptions(options, isRequired = false) {
            var rule = {
                required,
                inOptions: inArray(options),
                // $lazy: true,
                // $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule["required"];
            }
            return rule;
        }

        // Use for types with no 'required' parameter
        function notRequired(type) {
            var validations = Object.assign({}, type);
            delete validations["required"];

            return validations;
        }

        return {
            step: [
                // Step 1 - Registered Nurse Report
                {
                    incidentPreventable: inOptions(this.trueFalseOptions, false),
                    doneToPreventReOccurence: text(3, 500),
                    comments: text(3, 500, true),
                    registeredNurseSignature: text(3, 191, true),
                    familyMemberNotified: text(3, 191),
                    familyMemberNotifiedDate: notRequired(dateType),
                    familyMemberNotifiedTime: notRequired(timeType),
                    otherNotificationsToBeMade: text(3, 191),
                    requiredAssessmentsCompleted: inOptions(this.trueFalseOptions, false),
                },
            ],
        };
    },

    computed: {},

    methods: {
        onClickNext: function () {
            // Validate fields on current step
            this.v$.step[this.currentStep - 1].$touch();

            // if there are no errors in the current step
            if (!this.v$.step[this.currentStep - 1].$error) {
                // All steps
                if (this.currentStep < this.maxStep) {
                    // Proceed to next step
                    this.currentStep++;

                    // Final step
                } else if (this.currentStep == this.maxStep) {
                    // Initialize alerts and toast notifications for displaying message
                    const toastError = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: true,
                    });
                    const alertSuccess = Swal.mixin({
                        position: "center",
                        showConfirmButton: true,
                        timer: 3000,
                        timerProgressBar: true,
                    });

                    // Show button spinner
                    document.getElementById("submit-btn").innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>';
                    document.getElementById("submit-btn").disabled = true;
                    document.getElementById("last-back-btn").setAttribute("style", "display:none !important");

                    var formData = {};

                    // Loop through all steps
                    for (let i = 0; i < this.maxStep; i++) {
                        // Loop through all the step fields
                        for (const [key, value] of Object.entries(this.step[i])) {
                            formData[key] = value;
                        }
                    }

                    // Add residentID, userID, type and interventions fields
                    formData["residentID"] = formData["residentID"] ?? parseInt(this.residentId); // if residentId is selected on the form
                    formData["userID"] = this.userId;

                    this.updateAccidentIncidentReport(formData, toastError, alertSuccess);
                }
                this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
            }
        },

        onClickBack: function () {
            window.location = this.cancelUrl;
        },

        updateAccidentIncidentReport: function (formData, toastError, alertSuccess) {
            // Call the update endpoint
            axios
                .put(this.endpoint, formData)
                .then((response) => {
                    if (response.data.error == 403) {
                        console.log("Bad Request");
                        console.log(response.data);

                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({
                            type: "warning",
                            title: "The input fields are malformed and cant be processed.",
                        });
                    } else {
                        if (response.data.id == null) {
                            console.log("Validation Error");
                            console.log(response.data);

                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({
                                type: "warning",
                                title: "There are validation errors found on the form.",
                            });
                        } else {
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was updated
                            this.formSuccess = true;
                            window.residentId = this.residentId;

                            alertSuccess
                                .fire({
                                    title: "Success!",
                                    text: "The RN report has been added to the Accident / Incident Report.",
                                    icon: "success",
                                })
                                .then(function () {
                                    console.log("----" + formData["residentID"] + "-------");
                                    if (!_.isEmpty(formData["residentID"])) {
                                        window.location = "/residents/" + formData["residentID"] + "/care-plans?type=Short+Term";
                                    } else {
                                        window.location = "/accident-incident-reports";
                                    }
                                });
                        }
                    }
                })
                .catch((err) => {
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({type: "error", title: "Sorry, request failed to submit."}); // this error occurs when endpoint is wrong
                });
        },
    },
};
</script>
